
import { Vue, Component, Prop } from 'vue-property-decorator';
import store from '@/store';
import AppConfig from '@/AppConfig';
import StripeSubscriptionService from '@/Services/Subscription/StripeSubscriptionService';

@Component({})
export default class SelectFreePlanModal extends Vue {
  @Prop(Boolean)
  open!: boolean;

  showLoadingSubscription = false;
  stripeSubscriptionService: StripeSubscriptionService = new StripeSubscriptionService();

  /**
   * Select free plan
   * Will cancel existing plan or convert trial to free plan
   */
  async selectFreePlan(): Promise<void> {
    // Downgrade trial
    this.showLoadingSubscription = true;
    await this.stripeSubscriptionService
      .cancel('default')
      .then(() => {
        // Redirect to old app with URL param, which triggers a confirmation-banner, that the free plan is active
        let url = AppConfig.getOldAppBaseUrl() + '/manage/?freeplan=true';
        window.location.href = url;
      })
      .catch(() => {
        this.$emit('cancel');
        store.dispatch('layout/setSnackbar', {
          type: 'error',
          icon: 'forbidden-system',
          text: this.$t('fields.free_plan_modal.error').toString(),
          isSnackbar: true,
          active: true,
        });
      });
    this.showLoadingSubscription = false;
  }

  cancel(): void {
    this.$emit('cancel');
  }
}
